import { AreaTicketIndicatorsResponsible } from '../models/ResponsibleTicketIndicators'
import { TicketRepository } from '../repositories/TicketRepository'

export function ListResponsibleTicketIndicatorsCase(
  ticketRepository: TicketRepository
) {
  return async function (data: AreaTicketIndicatorsResponsible) {
    return await ticketRepository.listResponsibleTicketIndicators({ data })
  }
}
